var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(0 -0.001)",
    fill: "#bf83ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_393",
    "data-name": "Union 393",
    d: "M19264,1621.979h-3v-.9a6.03,6.03,0,0,0-1.937-4.395,4.236,4.236,0,0,0-.682-3.452,2.678,2.678,0,0,1,1.1-.232,2.7,2.7,0,0,1,2.248,4.192,4.516,4.516,0,0,1,2.273,3.887v.9Zm-13.5,0v-.9a4.5,4.5,0,0,1,2.234-3.887,2.7,2.7,0,1,1,4.5,0,4.505,4.505,0,0,1,2.271,3.887v.9Zm-1.5,0H19246v-.9a4.51,4.51,0,0,1,2.229-3.887,2.7,2.7,0,0,1,3.352-3.959,4.223,4.223,0,0,0-.678,3.466,6.006,6.006,0,0,0-1.9,4.38v.9Zm5.98-10.481a4.206,4.206,0,0,0-2.2.624l-.59-.261a4.34,4.34,0,0,0-.924-.29,4.585,4.585,0,0,1,1.465-1.378,2.7,2.7,0,0,1,2.254-4.192,2.7,2.7,0,0,1,2.252,4.192,4.535,4.535,0,0,1,1.484,1.373,4.387,4.387,0,0,0-.957.3l-.58.261A4.182,4.182,0,0,0,19254.975,1611.5Z",
    transform: "translate(-19235.002 -1594.99)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.dd025fc65aaa50b144f5e6ce79c60b5c.svg";
export { ForwardRef as ReactComponent };